<template>
    <v-row
            :style="block.height < 1 ? 'height: auto;': 'height:'+block.height+'px'"
            :align="align"
            class="testingheight"
            :justify="justify"
    >
        <v-col cols="12" v-for="(inner_block, inner_block_index) in blocks"
               style="position: relative;"
               :style="inner_block.stretch ? 'height:100%; background-color:'+inner_block.color+';' : ''"
               :sm="inner_block.sm"
               :md="inner_block.md"
               :lg="inner_block.lg"
               :class="'offset-sm-'+inner_block.sm_offset+' offset-md-'+inner_block.md_offset+' offset-lg-'+inner_block.lg_offset"
        >
            <div class="ai-btn--wrapper" v-if="inner_block.block_contents.length && inner_block.type !== 'list'">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn
                                style="height:28px; width: 28px;"
                                color="blue" fab small v-on="on" @click="setAiModel(inner_block, block_index, inner_block_index)">
                            <span class="material-symbols-outlined white--text">
                                    cognition
                            </span>
                        </v-btn>
                    </template>
                    <span>Ai Help</span>
                </v-tooltip>
            </div>

            <blocks-options-inner-block :item="inner_block"></blocks-options-inner-block>
            <v-row
                    :style="inner_block.stretch ? 'height:100%;': block.height < 1 ? 'height: auto;': 'height:'+block.height+'px'"
                    :justify="inner_block.justify"
                    :align="inner_block.align"
            >
                <v-col :class="'pt-'+inner_block.pt + ' '+ 'pr-'+inner_block.pr + ' '+
                                'pb-'+inner_block.pb + ' '+ 'pl-'+inner_block.pl + ' ' + ' mt-'+inner_block.mt+ ' mb-'+inner_block.mb+ ' mr-'+inner_block.mr+ ' ml-'+inner_block.ml"
                       cols="12" xs="12" sm="12"
                       md="12" lg="12">
                    <v-card :color="!inner_block.stretch ? inner_block.color : 'transparent'" class="pa-0"
                            :flat="!inner_block.outlined">
                        <v-card-text class="pa-0">
                            <v-row class="ma-0 ma-0">
                                <v-col
                                        v-if="inner_block.type === 'regular'"
                                        v-for="content in inner_block.block_contents"
                                        cols="12"
                                        :lg="content.lg"
                                        :md="content.md"
                                        :sm="content.sm"
                                        :xs="content.xs"
                                        :align="content.align"
                                        :class="'ma-0 pa-0 inner_block '"
                                >
                                    <blocks-content-block
                                            :type="content.type"
                                            :content="content"
                                    ></blocks-content-block>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                </v-col>

            </v-row>
        </v-col>
    </v-row>

</template>

<script>
import BlocksOptionsInnerBlock from '@/components/Blocks/Options/InnerBlock'
import BlocksContentBlock from '@/components/Blocks/ContentBlock'

export default {
    props: {
        block: Object,
        blocks: Array,
        align: String,
        justify: String,
        block_index: Number
    },
    components: {
        BlocksOptionsInnerBlock,
        BlocksContentBlock
    },
    data() {
        return {
            //
        }
    },
    methods: {
        setAiModel(block, block_index, inner_block_index) {
            this.$store.dispatch('setAiModel', {
                show: true,
                block: block,
                block_index: block_index,
                inner_block_index: inner_block_index,
                type: "campaign"
            });
        },
    },
}
</script>
